// i18next v26 ships complex generic types that conflict with TypeScript 4.x strict mode;
// cast to any to isolate the mismatch to this module.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
import i18nRaw from './i18n';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const i18n = i18nRaw as any;

function applyMeta(lng: string): void {
  const title: string = i18n.t('meta.title', { lng });
  const description: string = i18n.t('meta.description', { lng });

  document.title = title;

  const descEl = document.querySelector('meta[name="description"]');
  if (descEl) {
    descEl.setAttribute('content', description);
  }

  document.documentElement.lang = (lng as string).split('-')[0];
}

export function initDocumentMeta(): void {
  applyMeta(i18n.language as string);
  i18n.on('languageChanged', applyMeta);
}
